var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"px-icon",style:(_vm.iconStyle),attrs:{"src":_vm.iconFilePath,"alt":("Icon - " + _vm.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }